import { apiJson } from "../../../shared/lib/api-client.ts";
import type { ApiResponse } from "../../leaderboard/types/index.ts";
import type { ApiStatusData } from "../types/index.ts";

export async function getApiStatus(): Promise<ApiStatusData | null> {
  const payload = await apiJson<ApiResponse<ApiStatusData>>("/v1/api-status");
  return payload.data ?? null;
}
